<div class="w-full p-20 bg-pastel-blue border-box h-full scroll-y">
  <div class="flex gap-20 mb-20">
    <div>
      <img src="assets/cerfa-icon.svg" alt="list">
    </div>
    <div>
      <h3 class="light-blue no-margin text-lg">Édition automatique des CERFAS</h3>
      <p class="dark-gray no-margin text-sm">
        Remplissez les informations nécessaires pour générer automatiquement vos documents
        <span class="bold">CERFA</span> à la clôture du scrutin.
      </p>
    </div>
  </div>

  <div class="flex flex-column gap-20">
    <div class="p-20 bg-white border-box">
      <p class="dark-blue no-margin bold">
        Souhaitez-vous remplir le formulaire CERFA pour obtenir la génération automatique de vos CERFAs à la clôture du
        scrutin ?
      </p>
      <p class="dark-gray text-sm mb-10">
        Pour faciliter vos démarches post-électorales, vous pouvez renseigner dès maintenant les informations
        nécessaires à l’édition automatique des CERFA. À la clôture du scrutin, les documents réglementaires seront
        générés automatiquement, conformément aux données saisies.
      </p>
      <div>
        <div class="flex gap-10">
          <label class="flex align-items-center gap-5 pointer">
            <input type="radio" name="needCerfa" [value]="true" [(ngModel)]="needCerfa"> Oui
          </label>
          <label class="flex align-items-center gap-5 pointer">
            <input type="radio" name="needCerfa" [value]="false" [(ngModel)]="needCerfa"> Non
          </label>
        </div>
      </div>
    </div>

    <div *ngIf="needCerfa == false" class="bg-white p-20 flex flex-column gap-20">
      <div class="flex content-center gap-20">
        <img src="assets/clouds-icon.svg" alt="list">
        <img src="assets/ballot-icon.svg" alt="list">
        <img src="assets/clouds-icon.svg" alt="list">
      </div>
      <div>
        <h2 class="dark-blue no-margin text-center mb-5">Vous pouvez passer directement à l'étape suivante.</h2>
        <p class="mb-20 grey no-margin text-center text-sm">
          Les CERFAs ne seront pas générés automatiquement.
        </p>
      </div>
      <div class="margin-center w-fit">
        <button class="action-button" (click)="goToPollCreation()">Passer à la création du scrutin</button>
      </div>
    </div>

    <div *ngIf="needCerfa" class="flex flex-column gap-20">
      <app-cerfa-information [(venue)]="papValues.venue" (venueChange)="onVenueChange($event)"></app-cerfa-information>
      <app-cerfa-length [(termLength)]="papValues.termLength" [(headcount)]="papValues.headcount"
        [isValidated]="true" [(round)]="papValues.round" (headcountChange)="onHeadcountChange($event)"
        (termLengthChange)="onTermLengthChange($event)"></app-cerfa-length>
      <!--<app-cerfa-lists [(commonLists)]="papValues.commonLists" (commonListsChange)="onCommonListsChange($event)"></app-cerfa-lists>-->
      <app-cerfa-sirets [(sirets)]="papValues.sirets" (siretsChange)="onSiretsChange($event)"></app-cerfa-sirets>
      <app-cerfa-contact [(contact)]="papValues.contact" (contactChange)="onContactChange($event)"></app-cerfa-contact>

    </div>

  </div>

</div>
